'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var users = require('./users');
// const groups = require('./groups')

module.exports = function (views) {
  return _extends({}, views, {
    users: views.users ? _ramda2.default.mergeDeepLeft(views.users, users) : users
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/coact/views/withCoactViews.js
// module id = 1793
// module chunks = 0